// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OPdD","title":"styles_title__1okpI"};